import { jsx as _jsx } from "react/jsx-runtime";
export default function XShareButton(_ref) {
  var text = _ref.text,
      url = _ref.url,
      hashtags = _ref.hashtags,
      via = _ref.via,
      children = _ref.children;

  /**
   * twiterのシェアボタン
   * @param {Object} props
   * @param {String} props.text - ツイート本文
   * @param {String} props.url - ツイートに含めるURL
   * @param {String} props.hashtags - ハッシュタグ
   * @param {String} props.via - ツイートに含めるユーザー名
   * @param {React.element} props.children - このコンポーネントで括った親コンポーネントのDOM
   */
  var encodedText = encodeURIComponent(text);
  var encodedUrl = encodeURIComponent(url);
  var encodedHashtags = encodeURIComponent(hashtags);

  function subWindow(url) {
    var width = 550;
    var height = 400;
    var centerX = window.screenX + window.outerWidth / 2;
    var centerY = window.screenY + window.outerHeight / 2;
    var left = Math.round(centerX - width / 2);
    var top = Math.round(centerY - height / 2);
    window.open(url, "share window", "width=".concat(width, ",height=").concat(height, ",left=").concat(left, ",top=").concat(top, ",scrollbars=yes"));
  }

  return /*#__PURE__*/_jsx("div", {
    onClick: function onClick() {
      subWindow("https://twitter.com/intent/tweet?text=".concat(encodedText, "&url=").concat(encodedUrl, "&hashtags=").concat(encodedHashtags));
    },
    children: children
  });
}